import {Box} from "@mui/material";
import Typography from "@mui/material/Typography";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {surveyMarkdownToPlainText} from "../../shared/surveyMarkdownText.util";
import RunnerNumberField from "./RunnerNumberField";
import {RunnerQuestionProps} from "./runnerQuestion.types";

function NumberQuestion({question, localize, language, value, onAnswerChange}: RunnerQuestionProps) {
    const {t} = useTranslation(undefined, {lng: language});

    const [localNumber, setLocalNumber] = useState<number | undefined>(undefined);

    const number = value?.numberValue ?? localNumber;

    const pick = (next?: number) => {
        setLocalNumber(next);
        onAnswerChange?.({...value, numberValue: next});
    };

    const min = question.minNumber;
    const max = question.maxNumber;
    const hasMin = min !== undefined && min !== null;
    const hasMax = max !== undefined && max !== null;

    const rangeCaption = hasMin && hasMax
        ? t('Between {{from}} and {{to}}', {from: min, to: max})
        : hasMin
            ? t('{{min}} or more', {min})
            : hasMax
                ? t('{{max}} or less', {max})
                : undefined;

    return (
        <Box sx={{width: '100%'}}>
            <RunnerNumberField
                value={number}
                onChange={pick}
                min={min}
                max={max}
                placeholder={localize(question.placeholder)}
                ariaLabel={surveyMarkdownToPlainText(localize(question.title)) || undefined}
                decreaseLabel={t('Decrease')}
                increaseLabel={t('Increase')}
            />

            {!!rangeCaption && (
                <Typography variant={'body2'} color={'text.secondary'} sx={{mt: 0.5}}>
                    {rangeCaption}
                </Typography>
            )}
        </Box>
    );
}

export default NumberQuestion;
